import { createAction, props } from '@ngrx/store';
import { Order } from '@shared/models/order';

export const suspendOrder = createAction('[Orders] Suspend Order', props<{ orderId: number; reason: string }>());

export const suspendOrderSuccess = createAction('[Orders] Suspend Order Success', props<{ order: Order }>());

export const suspendOrderFailure = createAction('[Orders] Suspend Order Failure', props<{ error: any }>());
